module.exports = __webpack_public_path__ + "static/media/Lakshya.6b49d97c.jpg";